import React from "react";
import { SVG, IconProps } from "../SVG";

export const ShieldProtected = ({ color = "#13126C", strokeWidth = 2, ...props }: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 22" {...props}>
        <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={strokeWidth}
            d="m12.406 7.656-4.682 4.576-2.128-2.08M17 8.956c0 5.198-3.067 9.889-8 12.044-4.933-2.155-8-6.846-8-12.044v-5.96c5.733-2.662 10.933-2.662 16 0v5.96Z"
        />
    </SVG>
);
ShieldProtected.displayName = "ShieldProtected";
